// extracted by mini-css-extract-plugin
export var buttons = "_ai-0";
export var buttonsActive = "_ai-h";
export var cancelConfirm = "_ai-1";
export var closeButton = "_ai-2";
export var column = "_ai-3";
export var container = "_ai-4";
export var detailHeader = "_ai-6";
export var detailTitle = "_ai-7";
export var detailsContent = "_ai-5";
export var header = "_ai-8";
export var headerWithClose = "_ai-9";
export var icon = "_ai-a";
export var infoIcon = "_ai-c";
export var informationContainer = "_ai-b";
export var sideDrawer = "_ai-d";
export var sideDrawerOpen = "_ai-e";
export var stickyFooter = "_ai-f";
export var typeOption = "_ai-g";